import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
} from "reactstrap"
import classnames from "classnames"
import Skeleton from "react-loading-skeleton"
import { Link } from "react-router-dom"
import axios from "axios"
import moment from "moment"
import AssignDriver from "./AssignDriver"

const Requests = ({ setBooking }) => {
  const [activeTab, setActiveTab] = useState("new")
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const [showAssign, setShowAssign] = useState(false)
  const [selectedBooking, setSelectedBooking] = useState(null)

  useEffect(() => {
    setLoading(true)
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken")
        const response = await axios.get(
          `${process.env.REACT_APP_WEB_APP_URL}/api/web/booking-requests?filter=${activeTab}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        if (response.status === 200) {
          setData(response.data.data)
        }
      } catch (error) {
        console.error(error)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [activeTab, showAssign])

  return (
    <div
      className="position-absolute"
      style={{ top: "15px", left: "15px", width: "280px", zIndex: 10 }}
    >
      <Card className="p-2 shadow-sm" style={{ fontSize: "1rem" }}>
        <h5 className="mb-2">Requests</h5>
        <Nav tabs className="nav nav-tabs nav-tabs-custom nav-justified small">
          <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({ active: activeTab === "new" })}
              onClick={() => setActiveTab("new")}
            >
              <i className="bx bx-user-circle me-1"></i>
              <span>New</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({ active: activeTab === "waiting" })}
              onClick={() => setActiveTab("waiting")}
            >
              <i className="bx bx-clipboard me-1"></i>
              <span>Waiting</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({ active: activeTab === "assigned" })}
              onClick={() => setActiveTab("assigned")}
            >
              <i className="bx bx-mail-send me-1"></i>
              <span>Assigned</span>
            </NavLink>
          </NavItem>
        </Nav>

        {/* Scrollable list container */}
        {loading ? (
          <Skeleton count={5} height={30} />
        ) : (
          <div
            style={{ maxHeight: "450px", overflowY: "auto", marginTop: "5px" }}
          >
            {data.length > 0 ? (
              data.map(item => (
                <Card
                  onClick={() => setBooking(item)}
                  className="rounded-3 shadow-none border-2 mt-2, custom-card"
                  style={{ fontSize: "0.7rem", cursor: "pointer" }}
                >
                  <CardBody>
                    <Row className="mb-2">
                      <span className="text-muted">
                        {moment(item?.booking?.created_at).format("DD/MM h:mm A") ?? "N/A"}
                      </span>
                    </Row>
                    <span
                      className={`px-2 py-1 rounded-1 text-white ${
                        item?.booking?.status === "scheduled" || item?.booking?.status === "pending"
                          ? "bg-warning"
                          : item?.booking?.status === "new"
                          ? "bg-danger"
                          : item?.booking?.status === "assigned" ||
                            "scheduled_accept"
                          ? "bg-success"
                          : "bg-secondary"
                      }`}
                    >
                      {item?.booking?.status ?? "N/A"}
                    </span>
                    <Row className="mt-2">
                      <h6 className="mb-2">
                        {item?.booking?.id ? `#${item?.booking?.id}` : "N/A"}
                      </h6>
                    </Row>
                    <Row className="mb-2">
                      {/* <Col xs="4">
                        <div>Category</div>
                        <div className="fw-semibold">Ride hailing</div>
                      </Col> */}
                      <Col xs="6">
                        <div>Type</div>
                        <div className="fw-semibold">
                          {item?.booking?.type ?? "N/A"}
                        </div>
                      </Col>
                      <Col xs="6">
                        <div>Customer</div>
                        <div className="fw-semibold">
                          {item?.customer?.name ?? "N/A"}
                        </div>
                      </Col>
                    </Row>
                    <hr />
                    <ol
                      className="activity-checkout mb-0 px-2 mt-1"
                      style={{ fontSize: "0.8rem" }}
                    >
                      <li className="checkout-item">
                        <div className="avatar-sm checkout-icon p-1">
                          <div className="avatar-title rounded-circle bg-primary">
                            <i
                              className="mdi mdi-map-marker text-white"
                              style={{ fontSize: "14px" }}
                            ></i>
                          </div>
                        </div>
                        <div className="feed-item-list">
                          <div>
                            <h6 className="mb-1" style={{ fontSize: "0.8rem" }}>
                              {loading ? (
                                <Skeleton width={130} />
                              ) : (
                                item?.booking?.pickup_addr ?? "N/A"
                              )}
                            </h6>
                            {/* {loading ? (
                          <Skeleton width={100} />
                        ) : (
                          <p
                            className="text-muted text-truncate mb-1"
                            style={{ fontSize: "0.75rem" }}
                          >
                            93FH+66F, Misrata, Libye
                          </p>
                        )} */}
                          </div>
                        </div>
                      </li>

                      {item?.booking?.dest_addr && <li className="checkout-item">
                        <div className="avatar-sm checkout-icon p-1">
                          <div className="avatar-title rounded-circle bg-primary">
                            <i
                              className="mdi mdi-map-marker-check text-white"
                              style={{ fontSize: "14px" }}
                            ></i>
                          </div>
                        </div>
                        <div className="feed-item-list">
                          <h6 className="mb-1" style={{ fontSize: "0.8rem" }}>
                            {loading ? (
                              <Skeleton width={130} />
                            ) : (
                              item?.booking?.dest_addr ?? "N/A"
                            )}
                          </h6>
                        </div>
                      </li>}
                    </ol>

                    <Row>
                      <Col
                        xs={6}
                        className="d-flex align-items-center justify-content-center"
                      >
                        <Link
                          to={`/bookings/${item?.booking?.id}`}
                          className="custom-link"
                          style={{ fontSize: "0.8rem" }}
                        >
                          View details
                        </Link>
                      </Col>
                      {activeTab === "waiting" && (
                        <Col xs={6} className="d-flex justify-content-center">
                          <Button
                            onClick={() => {
                              setShowAssign(true)
                              setSelectedBooking(item)
                            }}
                            color="success btn-sm"
                          >
                            Assign
                          </Button>
                        </Col>
                      )}
                    </Row>
                  </CardBody>
                </Card>
              ))
            ) : (
              <div className="text-center p-4">No requests found.</div>
            )}
          </div>
        )}
        {showAssign && (
          <AssignDriver
            bookingData={selectedBooking}
            onClose={() => setShowAssign(false)}
          />
        )}
      </Card>
    </div>
  )
}

export default Requests
